import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { InboundDeliveryByIdQuery } from "../../../graphql/deliveryService/queries/inboundDeliveryById";
import { InboundDeliveryFragment } from "../../../models/autogenerated-deliveryService-gql/graphql";
import { handleError } from "../../../utils/graphqlHelper";
import { isNullOrEmpty } from "../../../utils/helper";

interface InboundDeliveryByIdQueryProps {
  id: string | undefined;
  dataAction: (data: InboundDeliveryFragment) => void;
  errorAction?: () => void;
}

const useInboundDeliveryByIdQuery = (props: InboundDeliveryByIdQueryProps) => {
  const { t } = useTranslation();
  const { id, dataAction, errorAction } = props;

  const query = useQuery(InboundDeliveryByIdQuery, {
    //fetchPolicy: "network-only",
    //nextFetchPolicy: "cache-first",
    skip: isNullOrEmpty(id),
    variables: { inboundDeliveryByIdInput: { id } },
    errorPolicy: "all", //returns errors and data if both exist at the same time
  });

  const { data, error } = query;

  const inboundDeliveryFragment = data?.inboundDeliveryById;

  useEffect(() => {
    if (!error) return;

    handleError(t("inboundDeliveryByIdQueryError"), error.message, errorAction);
  }, [error]);

  useEffect(() => {
    if (!data || !inboundDeliveryFragment) return;

    dataAction(inboundDeliveryFragment);
  }, [data]);

  return query;
};

export default useInboundDeliveryByIdQuery;
